import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { GeneralCDMSService } from 'src/app/Services/Global/GeneralCDMS/general-cdms.service';


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  standalone: false,
})
export class ForgotPasswordComponent {

  public forgotEmail: string = '';
  public forgotError: string = '';
  public forgotSuccess: boolean = false;
  public isLoading: boolean = false;

  constructor(private router: Router, private GeneralCDMS: GeneralCDMSService) {}

  async onSubmit(): Promise<void> {
    if (!this.forgotEmail.trim()) return;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(this.forgotEmail.trim())) {
      this.forgotError = 'Ingresa un correo electrónico válido';
      return;
    }

    this.forgotError = '';
    this.isLoading = true;

    try {
      const res = await firstValueFrom(
        this.GeneralCDMS.Request_Password_Recovery({ email: this.forgotEmail.trim() })
      );

      if (res.success && res.operation.success) {
        this.forgotSuccess = true;
      } else {
        this.forgotError = res.message || 'No se pudo procesar la solicitud';
      }

    } catch (e) {
      this.forgotError = 'Error de conexión con el servidor';
    } finally {
      this.isLoading = false;
    }
  }

  goBack(): void {
    this.router.navigate(['/']);
  }
}